<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>
            Aquisição da unidade em Goiânia (GO) e o início das exportações
          </h2>
          <p>
            A compra da unidade de Goiânia (GO),
            <strong>da Anglo</strong>, permitiu o acesso dos produtos da empresa
            ao mercado externo, realizando sua primeira exportação.
          </p>
          <img
            src="../assets/img/1996/1996-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>Plano Real muda a mesa dos brasileiros</h2>
          <p>
            Após décadas convivendo com a hiperinflação, o Brasil dos anos 1990
            vive uma de estabilidade econômica com a criação de uma nova moeda,
            o Real. O <strong>Estadão</strong> registrou o salto no consumo de
            alimentos como frango, comida congelada, iogurte e produtos
            industrializados de carne, colocando mais proteína na mesa dos
            brasileiros.
          </p>
          <div class="images">
            <img
              src="../assets/img/1996/1996-2.jpg"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/1994/07/01/g/19940701-36780-nac-0001-pri-a1-not-qaqwpke.jpg'
                )
              "
            />
            <img
              src="../assets/img/1996/1996-3.jpg"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/1996/01/08/g/19960108-37336-nac-0021-eco-b1-not-qagkeep.jpg'
                )
              "
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/1996/1996-1-full.jpg"),
          title:
            "1996 - Aquisição da unidade em Goiânia (GO), da Anglo, permitiu o acesso dos produtos da empresa ao exigente Mercado Comum Europeu.",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 488px 525px;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    @include media("<=desktop") {
      padding: 100px 20px 0;
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      h2 {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
      }

      &--black {
        padding-block: 50px;
        .images {
          display: flex;
          @include media("<=desktop") {
            flex-direction: column;
            gap: 20px;
            margin: 20px;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          @include media("<=desktop") {
            color: color(cWhite);
          }
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin-bottom: 10px;
          @include media("<=desktop") {
            color: color(cWhite);
          }
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: url("../assets/img/1996/1996-fundo.jpg");
      width: 47%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        width: 100%;
      }
    }
  }
}
</style>
